<template>
    <div>
        <section class="content-header mt-2">
            <h1 class="pull-left">
                <font-awesome-icon icon="building"/>
                Organizations
            </h1>
            <h3 class="pull-right">
                <router-link :to="{name : 'organization.create'}" class="btn btn-xs btn-success">
                    <font-awesome-icon icon="plus"/>
                </router-link>
            </h3>
        </section>
        <div class="content">
            <error-component
                    v-if="exceptions.length > 0"
                    v-bind="exceptions[0]">
            </error-component>
            <success-component
                    v-if="success.length > 0"
                    :message="success">
            </success-component>
            <div v-if="loading">
                <bouncing-component></bouncing-component>
            </div>
            <div v-else>
                <b-table :items="organizations" :fields="fields" class="table" stacked="sm">
                    <template slot="actions" slot-scope="row">
                        <b-button-group class="">
                            <router-link class="btn btn-xs btn-success" v-b-tooltip.hover title="Manage users" :to="{ name : 'organization.users', params: { organization_id: row.item.id } }">
                                <font-awesome-icon icon="users" />
                            </router-link>
                            <router-link v-if="row.item.owner.id === $auth.user().id" class="btn btn-xs btn-primary" v-b-tooltip.hover title="Edit" :to="{name : 'organization.edit', params: { organization_id: row.item.id }}">
                                <font-awesome-icon icon="edit" />
                            </router-link>
                            <button v-if="row.item.owner.id === $auth.user().id" type="submit" class="btn btn-danger btn-xs" v-b-tooltip.hover title="Delete"
                                    @click.prevent="del(row.item.id, row.index)">
                                    <font-awesome-icon icon="trash-alt"/>
                            </button>
                        </b-button-group>
                    </template>
                    <template slot="owner.name" slot-scope="row">
                        <b-badge v-if="row.item.owner.id === $auth.user().id" variant="info">You</b-badge>
                        {{row.item.owner.name}}
                    </template>
                </b-table>

                <b-pagination align="center" size="md"
                            :total-rows="pagination.totalRows"
                            v-model="pagination.currentPage"
                            :limit="pagination.limit"
                            :per-page="pagination.limit">
                </b-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import BouncingComponent from '../../components/Bouncing-loader.vue';
    import SuccessComponent from '../../components/Success.vue';
    import ErrorComponent from '../../components/ErrorView.vue';
    import {mapState} from "vuex";

    export default {
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'owner.name',
                        label: 'Owner',
                        sortable: true
                    },
                    {
                        key: 'plan.name',
                        label: 'Plan'
                    },
                    {
                        key: 'actions',
                        label: 'Actions'
                    }
                ],
                loading: true
            }
        },
        computed: {
            ...mapState({
                organizations: 'organizations',
                pagination: 'pagination',
                success: 'success',
                exceptions: 'exceptions'
            })
        },
        methods: {
            del(id, index) {
                this.$swal({
                    title: 'Be careful',
                    text: "Are you sure?",
                    type: 'warning',
                    width: '350px',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Confirm'
                }).then((result) => {
                    if (result.value) {
                        this.$store.dispatch('deleteOrganization', {id: id, index: index}).then(() => {
                            if (id === this.$store.getters.getOrganizationSelected) {
                                this.$store.commit('SET_ORGANIZATION_SELECTED', -1);
                            }
                        });
                    }
                })
            },
        },
        components: {
            SuccessComponent,
            ErrorComponent,
            BouncingComponent
        },
        created() {
            this.$store.dispatch('fetchOrganizations').finally(() => {
                this.loading = false;
            });
        },
        beforeDestroy() {
            this.$store.dispatch('clearMessages');
        },
    }
</script>
